import { useMutation } from 'react-query';

import { updateDocumentChapter } from '../infrastructure/update-document-chapter';
import { useInvalidateAllDocuments } from './utils/invalidate-all-documents';

export const useUpdateDocumentChapterMutation = () => {
    const invalidateAll = useInvalidateAllDocuments();

    return useMutation({
        mutationFn: updateDocumentChapter,
        onSuccess: () => {
            invalidateAll();
        },
    });
};
